import { createRouter, createWebHistory } from "vue-router";

// guards
import { authGuard, resetStudentStateGuard, searchedStudentIdGuard } from "./guards";

/** layout */
import AuthLayout from "@/apps/layouts/AuthLayout.vue";
import DefaultLayout from "@/apps/layouts/DefaultLayout.vue";
import ExtendsLayout from "@/apps/layouts/ExtendsLayout.vue";
import NotFoundLayout from "@/apps/layouts/NotFoundLayout.vue";

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: "/",
            redirect: "/auth",
        },
        {
            path: "/auth",
            name: "auth",
            component: () => import("@/pages/auth/ui/Index.vue"),
            meta: {
                requiresAuth: false,
                layout: AuthLayout,
            },
        },
        {
            path: "/dashboard",
            name: "dashboard",
            component: () => import("@/pages/home/ui/IndexPage.vue"),
            meta: {
                requiresAuth: true,
                layout: DefaultLayout,
            },
        },
        {
            path: "/student-setting/",
            name: "student-setting",
            component: () => import("@/pages/student-setting/ui/StudentSearchSection.vue"),
            meta: {
                requiresAuth: true,
                layout: DefaultLayout,
            },
        },
        {
            path: "/student-setting/:id",
            name: "student-setting-id",
            component: () => import("@/pages/student-setting/ui/IndexPage.vue"),
            meta: {
                requiresAuth: true,
                layout: DefaultLayout,
            },
            children: [
                {
                    path: "student-information",
                    name: "student-information",
                    component: () =>
                        import("@/pages/student-setting/ui/student-information/index.vue"),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: "setting-base-study",
                    name: "setting-base-study",
                    component: () =>
                        import(
                            "@/pages/student-setting/ui/setting-study/setting-base-study/index.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: "setting-concept-enhancement",
                    name: "setting-concept-enhancement",
                    component: () =>
                        import(
                            "@/pages/student-setting/ui/setting-study/setting-concept-enhancement/index.vue"
                        ),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: "class-information",
                    name: "class-information",
                    component: () =>
                        import("@/pages/student-setting/ui/class-information/index.vue"),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: "curriculum",
                    name: "curriculum",
                    component: () => import("@/pages/student-setting/ui/curriculum/index.vue"),
                    meta: {
                        requiresAuth: true,
                    },
                },
                // {
                //     path: "latest-study-reports",
                //     name: "latest-study-reports",
                //     component: () =>
                //         import("@/pages/student-setting/ui/latest-study-reports/index.vue"),
                //     meta: {
                //         requiresAuth: true,
                //     },
                // },
                // {
                //     path: "counselling-history",
                //     name: "counselling-history",
                //     component: () =>
                //         import("@/pages/student-setting/ui/counselling-history/index.vue"),
                //     meta: {
                //         requiresAuth: true,
                //     },
                // },
            ],
        },
        {
            path: "/class-management",
            name: "class-management",
            component: () => import("@/pages/class-management/ui/IndexPage.vue"),
            meta: {
                requiresAuth: true,
                layout: DefaultLayout,
            },
        },
        {
            path: "/challenge-up",
            name: "challenge-up",
            component: () => import("@/pages/challenge-up/ui/IndexPage.vue"),
            children: [
                {
                    path: "before-challenge-form",
                    name: "before-challenge-form",
                    component: () => import("@/pages/challenge-up/ui/before-challenge/index.vue"),
                    meta: {
                        requiresAuth: true,
                        layout: DefaultLayout,
                    },
                },
                {
                    path: "after-challenge-form",
                    name: "after-challenge-form",
                    component: () => import("@/pages/challenge-up/ui/after-challenge/index.vue"),
                    meta: {
                        requiresAuth: true,
                        layout: DefaultLayout,
                    },
                },
            ],
            meta: {
                requiresAuth: true,
                layout: DefaultLayout,
            },
        },
        {
            path: "/concept-enhancement",
            name: "concept-enhancement",
            component: () => import("@/pages/concept-enhancement/ui/IndexPage.vue"),
            meta: {
                requiresAuth: true,
                layout: DefaultLayout,
            },
        },
        {
            path: "/ai-tutor",
            name: "ai-tutor",
            component: () => import("@/pages/ai-tutor/ui/IndexPage.vue"),
            meta: {
                requiresAuth: true,
                layout: ExtendsLayout,
            },
        },
        {
            path: "/:pathMatch(.*)*",
            name: "NotFound",
            component: () => import("@/pages/404.vue"),
            meta: {
                requiresAuth: false,
                layout: NotFoundLayout,
            },
        },
    ],
});

/** router가 작동하기 전에 인증 및 상태를 관리합니다 */
router.beforeEach((to, from, next) => {
    // 1. 인증 확인
    const authResult = authGuard(to, from);

    // 리디렉션이 필요한 경우
    if (typeof authResult === "string") {
        next(authResult);
        return;
    }

    // 2. 학생 상태 리셋 처리
    resetStudentStateGuard(to, from);

    // 3. 새로고침 시 검색 학생의 id 가 reset 될 경우 학생관리로 리셋
    const searchedStudentIdResult = searchedStudentIdGuard(to, from);

    if (typeof searchedStudentIdResult === "string") {
        console.log("searchedStudentIdResult", searchedStudentIdResult);
        next(searchedStudentIdResult);
        return;
    }

    // 3. 내비게이션 허용
    next();
});

export default router;
